import { Button, Dialog, DialogActions, DialogContent, Grid, MenuItem, Select } from '@mui/material'
import { useEffect, useState } from 'react'
import DraggableDialogTitle from '../../../common/DraggableDialogTitle'

type Props = {
    open: boolean
    onClose: () => void
    expiryMenu: {
        value: string
        label: string
    }[]
    currentSelectedExpiry: {
        expirySeconds: string
        expiry: string
    } | undefined
    onSubmit: (selectedExpiry: {
        expirySeconds: string
        expiry: string
    }) => void
}

const OiSettingsDialog = (props: Props) => {
    const { open, onClose, expiryMenu, currentSelectedExpiry, onSubmit } = props
    const [selectedExpiry, setSelectedExpiry] = useState(currentSelectedExpiry)

    useEffect(() => {
        setSelectedExpiry(currentSelectedExpiry)
    }, [currentSelectedExpiry])
    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <DraggableDialogTitle>OI Settings</DraggableDialogTitle>
            <DialogContent>
                <Grid container gap={2} alignItems={'center'}>
                    <Grid item>Select Expiry</Grid>
                    <Grid item>
                        <Select
                            size="small"
                            value={selectedExpiry?.expirySeconds}
                        >
                            {
                                expiryMenu.map((expiry) => {
                                    return (
                                        <MenuItem
                                            key={expiry.value}
                                            value={expiry.value}
                                            onClick={() => {
                                                setSelectedExpiry({
                                                    expiry: expiry.label,
                                                    expirySeconds: expiry.value
                                                })
                                            }
                                            }>
                                            {expiry.label}
                                        </MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        if (selectedExpiry) {
                            onSubmit(selectedExpiry)
                            onClose()
                        }
                    }}
                >Ok</Button>
            </DialogActions>
        </Dialog>
    )
}

export default OiSettingsDialog